import { CircularProgress } from '@mui/material'
import { useState } from 'react'
import SingleExpandAccordionWrapper from 'src/consumer/components/common/accordion/SingleExpandAccordionWrapper'
import FeeModelViewer from './FeeModelViewer'

export default function FeeModelsDisplay({
  entityFeeModels,
  inApplicableEntityFeeModels,
  feeModels,
  feeModelGroups,
  forMentor = false,
  loading = false
}) {
  const [expandedAccordion, setExpandedAccordion] = useState(null)

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center flex-grow">
        <CircularProgress />
      </div>
    )
  }

  return (
    <div
      className="d-flex flex-column gap-4 px-4"
      style={{ maxWidth: '968px', width: '100%', margin: '20px auto 10px' }}
    >
      {/* Active Fee Models Section */}
      {entityFeeModels?.length > 0 && (
        <div className="d-flex flex-column gap-4">
          <h3 className="mb-0" style={{ fontWeight: 'bold' }}>
            Currently Active Models
          </h3>
          {entityFeeModels.map((model, idx) => (
            <FeeModelViewer
              key={model?.id}
              allFeeModels={feeModels}
              entityFeeModel={model}
              modelNo={idx + 1}
              feeModelGroups={feeModelGroups}
              forMentor={forMentor}
            />
          ))}
        </div>
      )}

      {/* Inactive Fee Models Accordion */}
      {inApplicableEntityFeeModels?.length > 0 && (
        <div className="d-flex flex-column gap-2 mt-4">
          <SingleExpandAccordionWrapper
            isExpanded={expandedAccordion === 'inactive'}
            expandOnChange={() => setExpandedAccordion(expandedAccordion === 'inactive' ? null : 'inactive')}
            expandedItemIdentifier="inactive"
            accordionSummaryHeading={
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontWeight: 'bold' }}>
                  View {inApplicableEntityFeeModels.length} Inactive Model{inApplicableEntityFeeModels.length !== 1 ? 's' : ''}
                </span>
              </div>
            }
            accordionProps={{
              style: {
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6'
              }
            }}
          >
            <div className="d-flex flex-column gap-4">
              {inApplicableEntityFeeModels.map((model, idx) => (
                <FeeModelViewer
                  key={model?.id}
                  allFeeModels={feeModels}
                  entityFeeModel={model}
                  modelNo={entityFeeModels?.length + idx + 1}
                  feeModelGroups={feeModelGroups}
                  forMentor={forMentor}
                />
              ))}
            </div>
          </SingleExpandAccordionWrapper>
        </div>
      )}

      {/* No models message */}
      {(!entityFeeModels?.length && !inApplicableEntityFeeModels?.length) && (
        <div className="text-center mt-4">
          <h4 style={{ color: '#6c757d' }}>No fee models found</h4>
        </div>
      )}
    </div>
  )
}